<template>
  <!-- 1.all-container-start -->
  <div class="all-container">
    <div class="df-spzx-b">
      <div class="df-spzx-ba" :style="topStyle"></div>
    </div>
    <div class="df-spzx-b2">
      <div v-html="cozyTip" class="df-spzx-b2m">
        温馨提示：欢迎来到开元天汇，如您遇到任何问题可以拨打客服电话400-819-**
      </div>
    </div>
    <div class="df-spzx-a">
      <el-link @click="exitLogin" type="danger">登出</el-link>
      <span v-html="sysTitle">易代发</span>
    </div>
    <div class="df-spzx-c">
      <div class="df-spzx-ca">
        <span class="df-spzx-caspan">
          <span :class="sstype == 0 ? 'on' : ''" @click="setstype(0)"
            >全部</span
          >
          <span :class="sstype == 1 ? 'on' : ''" @click="setstype(1)"
            >品牌</span
          >
          <span :class="sstype == 2 ? 'on' : ''" @click="setstype(2)"
            >价格</span
          >
        </span>
        <input
          v-model="searchText"
          type="text"
          placeholder="请输入搜索商品名称"
          class="ss-inp"
        />
        <div @click="search" class="ss-but"></div>
      </div>
    </div>
    <div class="df-spzx-d">
      <div class="df-spzx-da">
        <div class="df-maina-ddtit" v-if="butsIndex > 0">
          <span>{{ btns[butsIndex].name }}</span>
        </div>
        <div
          :class="index == butsIndex ? 'df-spzx-dabox on' : 'df-spzx-dabox'"
          @click="clickedBtns(index)"
          v-for="(item, index) of btns"
          :key="index"
        >
          <div class="df-spzx-dam">{{ item.name }}</div>
          <div class="df-spzx-daico"></div>
        </div>
      </div>
      <div class="df-spzx-db">
        <div class="df-spzx-dba" v-if="butsIndex == 0">
          <span
            @click="handleUserClickedTabbar(index)"
            :class="index == tabbarIndex ? 'on' : ''"
            v-for="(item, index) of tabbar"
            :key="index"
          >
            {{ item.name }}
          </span>
        </div>
        <div class="df-spzx-dbb">
          <!-- 商品中心->商品列表 -->
          <goods-list
            @addSuccess="addSuccess"
            v-if="btns[butsIndex].name == '商品列表'"
          ></goods-list>

          <!-- 商品中心->商品列表 -->

          <!-- 商品中心->定制产品组合 -->
          <setmeal-list
            :obj="obj"
            v-else-if="btns[butsIndex].name == '定制产品组合'"
          ></setmeal-list>
          <!-- 商品中心->定制产品组合 -->

          <!-- 商品中心->项目产品组合 -->
          <setmeal-list
            :obj="obj"
            v-else-if="btns[butsIndex].name == '项目产品组合'"
          ></setmeal-list>
          <!-- 商品中心->项目产品组合 -->

          <!-- 商品中心->项目产品组合 -->
          <setmeal-list
            :obj="obj"
            v-else-if="btns[butsIndex].name == '定制大礼包'"
          ></setmeal-list>
          <!-- 商品中心->项目产品组合 -->

          <!-- 商品中心->项目产品组合 -->
          <setmeal-list
            :obj="obj"
            v-else-if="btns[butsIndex].name == '礼册产品组合'"
          ></setmeal-list>
          <!-- 商品中心->项目产品组合 -->

          <!-- 商品中心->公共套餐 -->
          <publice-tc
            v-else-if="btns[butsIndex].name == '公共套餐'"
          ></publice-tc>
          <!-- 商品中心->公共套餐 -->
        </div>
      </div>
    </div>

    <!-- 2.main-container-start -->
    <!--<div class="main1-container">
      <div class="main flexStyle3">
        <div class="left">
          <user-info></user-info>
          <div class="bottom">
            <div
              :class="index == butsIndex ? 'hands item item-on' : 'hands item'"
              @click="clickedBtns(index)"
              v-for="(item, index) of btns"
              :key="index"
            >
              <div class="left oneLine">{{ item.name }}</div>
              <div v-if="index == butsIndex" class="right rightright"></div>
            </div>
          </div>
        </div>
        
      </div>
    </div>-->
    <!-- 2.main-container-end -->

    <!-- 100.footer-container-start -->
    <c-footer></c-footer>
    <!-- 100.footer-container-end -->

    <div class="df-fdrbox">
      <h3>{{ userInfo.customerName || "" }}</h3>
      <h2>账户余额</h2>
      <span>{{ to_f(userInfo.balance || "0.00") }}</span>
      <div class="df-fdrboxhref" @click="$router.push('/financeCenter')">
        充值入口
      </div>
      <em @click="exitLogin">登出</em>
    </div>

    <div class="df-fdlbox">
      <i v-if="goodsNumber > 0" class="df-fdlbox-num">{{ goodsNumber }}</i>
      <span class="df-fdlboxspan" @click="shoppingCar"></span>
      <div class="df-fdrboxhref df-fdlbox-hrefa" @click="shoppingCar">
        购物车
      </div>
      <div class="df-fdlbox-a">
        <!-- <div class="df-fdrboxhref" @click="$router.push('')">在线客服</div>
        <div class="df-fdrboxhref" @click="$router.push('')">售后处理</div> -->
      </div>
      <div class="df-fdlbox-b">
        <div class="df-fdrboxhref" @click="$router.push('/goodsCenter')">
          商品中心
        </div>
        <div class="df-fdrboxhref on" @click="backtop">回顶部</div>
        <div class="df-fdrboxhref" @click="$router.push('/financeCenter')">
          充值中心
        </div>
        <div class="df-fdrboxhref" @click="$router.push('/orderCenter')">
          订单中心
        </div>
      </div>
    </div>
  </div>
  <!-- 1.all-container-end -->
</template>

<script>
import footer from "../../components/footer/footer";
//import userInfo from "../../components/userInfo/userInfo";
import goodsList from "./components/goodsList";
import publiceTc from "./components/publiceTc";
import setmealList from "./components/setmealList";

import {
  shoppingCarNumber,
  getUserBaseInfoRequest,
} from "../../public/js/service";

export default {
  data() {
    // 1.data
    return {
      cozyTip: "",
      sysTitle: "",
      btns: [
        // 1.1.buttons
        { name: "商品列表", id: 1 },
        { name: "定制产品组合", id: 2 },
        { name: "项目产品组合", id: 3 },
        { name: "定制大礼包", id: 4 },
        { name: "礼册产品组合", id: 5 },
        // {name: '公共套餐', id: 6},
      ],
      obj: null,
      butsIndex: 0, // 1.2.当前激活按钮
      goodsNumber: 0, // 1.3.购物车商品数量
      searchText: "",
      sstype: 0,
      tabbar: [
        // 1.1.tabbar按钮
        { name: "商品中心", id: 1 },
        { name: "订单中心", id: 2 },
        { name: "结算中心", id: 3 },
        { name: "会员中心", id: 4 },
        { name: "帮助中心", id: 5 },
      ],
      tabbarIndex: 0,
      userInfo: [],
      topImg: "",
      topStyle: "",
    };
  },

  components: {
    // 2.components
    cFooter: footer, // 2.2.页面底部
    //userInfo, // 2.3.左侧右上角客户信息
    goodsList, // 2.4.右侧下部分商品列表
    publiceTc, // 2.5.右侧下部分公共套餐
    setmealList,
  },

  methods: {
    // 3.methods
    clickedBtns(index) {
      // 3.1.按钮回调
      if (this.butsIndex != index) {
        this.butsIndex = index;
        this.obj = this.btns[index];
      }
    },

    getGoodsNumber() {
      // 3.2.获取购物车信息
      shoppingCarNumber().then((res) => {
        if (res) {
          this.goodsNumber = res.data;
        }
      });
    },

    addSuccess() {
      // 3.3.添加购车成功
      this.getGoodsNumber();
    },

    shoppingCar() {
      // 2.3.购物车
      this.$router.push("/shoppingCar");
    },

    backtop() {
      var timer = setInterval(function() {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed;
        this.isTop = true;
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 30);
    },

    getUserInfo() {
      // 3.4.获取用户信息
      getUserBaseInfoRequest().then((res) => {
        if (res) {
          this.userInfo = res.data;
          localStorage.userInfo = JSON.stringify(res.data);
        }
      });
    },

    exitLogin() {
      this.loginOutCustomerRequest().then((res) => {
        if (res) {
          // 修改，后面退出登录可能还要删除某些东西
          localStorage.removeItem("loginStatus");
          localStorage.removeItem("token");
          localStorage.removeItem("userInfo");
          this.$router.push("/login");
        }
      });
    },

    search() {
      if (this.searchText.trim()) {
        localStorage.searchText = this.searchText;
        localStorage.searchType = this.sstype;
        setTimeout(() => {
          localStorage.removeItem("searchText");
        }, 3000);
        this.$router.push(
          "/goodsCenter?searchText=" +
            (this.searchText + Math.random())
        );
      } else {
        this.$message.error("请填写搜索内容");
      }
    },

    setstype(e) {
      this.sstype = e;
    },

    // 2.methods
    handleUserClickedTabbar(index) {
      // 2.1.用户点击tabbar按键
      // if (index!=this.tabbarIndex){
      //     this.tabbarPageChange(index);
      // }
      this.tabbarPageChange(index);
    },

    tabbarPageChange(index) {
      // 2.2.tabbar页面切换方法
      switch (index) {
        case 0:
          this.$router.push("/goodsCenter?buttonIndex=0");
          break;
        case 1:
          localStorage.orderButtonIndex = 0;
          this.$router.push("/orderCenter?buttonIndex=0");
          break;
        case 2:
          this.$router.push("/financeCenter?buttonIndex=0");
          break;
        case 3:
          this.$router.push("/ownInfo?buttonIndex=0");
          break;
        case 4:
          this.$router.push("/helpInfo?buttonIndex=0");
          break;
      }
      this.$emit("goOnePage");
    },
  },

  mounted() {
    // 4.mounted
    if (localStorage.token) {
      if (localStorage.baseInfo) {
        let r = JSON.parse(localStorage.baseInfo);
        if (r) {
          this.sysTitle = r.web_name || "";
          this.cozyTip = r.web_cozy_tip || "";
          this.topImg = r.web_good_top || "";
          if (this.topImg != "") {
            this.topStyle =
              "background: url(" +
              this.topImg +
              ") no-repeat 0 0;background-size: auto 100%;";
          }
        }
      }
      if (localStorage.searchType) {
        this.sstype = localStorage.searchType;
      }

      this.token = localStorage.token;
      this.getGoodsNumber(); // 4.1.获取商品数量
      this.getUserInfo();
      let pobj = JSON.parse(this.$route.query.pobj);
      this.butsIndex = this.$route.query.index;
      if (pobj) {
        this.obj = pobj;
      } else {
        this.obj = this.btns[0];
      }
    }
  },
};
</script>

<style lang="scss">
.all-container {
  .df-fdrbox {
    width: 99px;
    position: fixed;
    right: 10px;
    top: 25%;
    z-index: 99;
    background: #fff url(../../image/bg2.png) no-repeat center 0;
    padding: 100px 0 20px;
    box-shadow: 0 0 6px 3px rgba(0, 0, 0, 0.15);
    border-radius: 14px;
    text-align: center;
    h3 {
      font-weight: 300;
      font-size: 14px;
      color: #333;
      padding-bottom: 10px;
      border-bottom: 1px dotted #ddd;
      margin-bottom: 8px;
    }
    h2 {
      font-weight: 300;
      font-size: 16px;
      color: #777;
    }
    span {
      font-weight: bold;
      display: inline-block;
      font-size: 16px;
      color: #e0631d;
      padding: 6px 0;
      width: 85%;
      border: 1px solid #e3e3e3;
      margin: 10px 0;
    }
    em {
      font-weight: 300;
      display: inline-block;
      font-size: 16px;
      color: #e0631d;
      font-style: inherit;
      margin-top: 10px;
      cursor: pointer;
    }
    .df-fdrboxhref {
      width: 100%;
      background: #4ea5db;
      padding: 3px 0;
      font-size: 14px;
      color: #fff;
      cursor: pointer;
    }
  }

  .df-fdlbox {
    width: 110px;
    position: fixed;
    left: 10px;
    top: 25%;
    z-index: 999;
    background: #fff url(../../image/bg4.png) no-repeat 45% 26px;
    background-size: 72px auto;
    padding: 115px 0 20px;
    box-shadow: 0 0 6px 3px rgba(0, 0, 0, 0.13);
    border-radius: 3px;
    text-align: center;
    span {
      font-weight: bold;
      display: inline-block;
      font-size: 16px;
      color: #e0631d;
      padding: 6px 0;
      width: 85%;
      border: 1px solid #e3e3e3;
      margin: 10px 0;
    }
    .df-fdlboxspan {
      display: block;
      position: absolute;
      left: 10%;
      top: 0;
      width: 80%;
      height: 70px;
      cursor: pointer;
      border: none;
    }
    .df-fdlbox-hrefa {
      width: 100%;
      background: #4ea5db;
      padding: 3px 0;
      font-size: 14px;
      color: #fff;
      cursor: pointer;
    }
    .df-fdlbox-a {
      width: 85%;
      margin: 0 auto;
      padding: 10px 0;
      .df-fdrboxhref {
        display: block;
        font-size: 16px;
        color: #777;
        padding: 6px 0;
        border: 1px solid #e3e3e3;
        margin: 5px 0;
        cursor: pointer;
      }
      .df-fdrboxhref:hover {
        color: #e47f3e;
        text-decoration: none;
        border: 1px solid #e47f3e;
      }
      .df-fdrboxhref:after {
        border: none;
      }
    }
    .df-fdlbox-b {
      width: 70%;
      margin: 0 auto;
      .df-fdrboxhref {
        display: block;
        font-size: 14px;
        color: #777;
        padding: 6px 0;
        border: 1px dotted #ddd;
        margin-top: -1px;
        font-weight: bold;
        cursor: pointer;
      }
      .df-fdrboxhref:hover,
      .df-fdrboxhref.on {
        color: #e47f3e;
        text-decoration: none;
        border: 1px dotted #ddd;
      }
      .df-fdrboxhref:after {
        border: none;
      }
    }
    .df-fdlbox-num {
      display: inline-block;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background: #4ea5db;
      position: absolute;
      left: 45%;
      top: 35px;
      font-size: 12px;
      color: #fff;
      font-style: initial;
    }
  }
}
</style>
